var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-commitment-page"},[_c('gantt-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }